export function openModal(dispatch, payload) {
  dispatch({type: 'OPEN_MODAL', payload: payload});
}

export function closeModal(dispatch) {
  dispatch({type: 'CLOSE_MODAL'});
}
